import React, { useEffect } from 'react';
import AutoSuggestShareUsers from '../utils/components/AutoSuggestShareUsers/AutoSuggestShareUsers';
import { useDispatchLoadShareUsers } from 'app/store/shareUsers/dispatcher';

export interface ShareLayoutContentProps {
    layoutName: string;
    username: string;
    onUsernameChanged: (username: string) => void;
    onEnter: () => void;
    error: string;
    isInvalid: boolean;
}

export default function ShareLayoutContent(props: ShareLayoutContentProps) {
    const {
        layoutName,
        username,
        onUsernameChanged,
        error,
        isInvalid,
        onEnter,
    } = props;
    const dispatchLoadShareUsers = useDispatchLoadShareUsers();

    useEffect(() => {
        dispatchLoadShareUsers();
    }, [dispatchLoadShareUsers]);

    return (
        <div className="ShareLayoutContent modal-content">
            <span className="title">{`Share a copy of '${layoutName}'`}</span>
            <div className="message">
                Select the username of a colleague to send them a copy of this
                layout. It will appear in their Layout Manager as an available
                layout to use or edit as they choose.
            </div>

            <div className="input-with-label">
                <div className="label">Colleague&apos;s username</div>
                {error && <div className="error">{error}</div>}

                <AutoSuggestShareUsers
                    onChange={onUsernameChanged}
                    onEnter={onEnter}
                    value={username}
                    error={!!error && isInvalid}
                />
            </div>
        </div>
    );
}
